import { useState } from 'react';
import useDidMountEffect from "./useDidMountEffect";
import {useDealContext} from "../contexts/DealContext";

const useTaxStateHook = (tax) => {
    const { dealState, setDealStateWithUpdate, updateDealResponse } = useDealContext()
    const [taxState, setTaxState] = useState(tax)

    const setTaxStateWithUpdate = (newState, update = true) => {
        return setTaxState({...taxState, ...newState, _update: update})
    }

    useDidMountEffect(function updateTaxFromBackend(){
        setTaxState({...tax, _update: false})
    }, [])

    useDidMountEffect(function updateDealStateTaxes(){
        if (taxState) {
            let newDealState = structuredClone(dealState)
            let taxes = newDealState.formatted_quote.taxes

            taxes.forEach((el, index, array) => {
                if (taxState.name === el.name) {
                    array[index] = taxState
                }
            })

            newDealState.formatted_quote.taxes = taxes
            setDealStateWithUpdate(newDealState, taxState._update)
        }
    }, [taxState])

    useDidMountEffect(function updateTaxStateFromBackend(){
        if (
            updateDealResponse?.data?.data &&
            !updateDealResponse.loading &&
            !updateDealResponse.error &&
            taxState
        ) {
            const newDealState = updateDealResponse?.data?.data

            const taxFromBackend = newDealState.formatted_quote.taxes.find(t => String(t.name) === String(tax.name))

            if (taxFromBackend) {
                setTaxState({...taxFromBackend, _update: false})
            }
        }
    }, [updateDealResponse])

    return [taxState, setTaxStateWithUpdate]
}

export default useTaxStateHook;